import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { supabase } from '../lib/supabaseClient';
import SurveyRunningTotal from './SurveyRunningTotal';
import './Blog.css';

// ─── POST LIST ───────────────────────────────────────────────────────────────
const PostList = ({ posts, onSelect }) => (
  <div className="blog-post-list">
    {posts.map(post => (
      <button
        key={post.id}
        className="blog-post-card"
        onClick={() => onSelect(post)}
      >
        <div className="blog-post-card-meta">
          {new Date(post.published_at).toLocaleDateString('en-US', {
            weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
          })}
        </div>
        <div className="blog-post-card-title">{post.title}</div>
        {post.excerpt && (
          <div className="blog-post-card-excerpt">{post.excerpt}</div>
        )}
        <div className="blog-post-card-cta">Read more →</div>
      </button>
    ))}
  </div>
);

// ─── SINGLE POST ─────────────────────────────────────────────────────────────
const SinglePost = ({ post, onBack }) => (
  <div className="blog-post-single">
    <button className="blog-back-btn" onClick={onBack}>← Back to posts</button>
    <div className="blog-post-meta">
      {new Date(post.published_at).toLocaleDateString('en-US', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
      })}
    </div>
    <h1 className="blog-post-title">{post.title}</h1>
    <div className="blog-post-body">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {post.body}
      </ReactMarkdown>
    </div>
    {post.related_survey_question_id && (
      <SurveyRunningTotal questionId={post.related_survey_question_id} />
    )}
  </div>
);

// ─── BLOG ────────────────────────────────────────────────────────────────────
const Blog = ({ onNavigate }) => {
  const [posts,    setPosts]    = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    supabase
      .from('blog_posts')
      .select('id, title, slug, excerpt, body, published_at, related_survey_question_id')
      .not('published_at', 'is', null)
      .lte('published_at', new Date().toISOString())
      .order('published_at', { ascending: false })
      .then(({ data }) => {
        setPosts(data || []);
        setLoading(false);
      });
  }, []);

  return (
    <div className="blog-page">
      <nav className="blog-nav">
        <div className="blog-nav-logo" onClick={() => onNavigate('home')}>
          Umpire<span>IQ</span>
        </div>
        <div className="blog-nav-links">
          <button className="blog-nav-link" onClick={() => onNavigate('home')}>Home</button>
          <button className="blog-nav-link" onClick={() => onNavigate('signup')}>Sign Up</button>
          <button className="blog-nav-link" onClick={() => onNavigate('login')}>Sign In</button>
        </div>
      </nav>

      <div className="blog-body">
        {selected ? (
          <SinglePost post={selected} onBack={() => setSelected(null)} />
        ) : (
          <>
            <div className="blog-header">
              <div className="blog-eyebrow">UmpireIQ Insights</div>
              <h1 className="blog-title">The Weekly Recap</h1>
              <p className="blog-subtitle">
                Data, community pulse, and field perspective — every Friday.
              </p>
            </div>
            {loading ? (
              <div className="blog-loading">Loading…</div>
            ) : posts.length === 0 ? (
              <div className="blog-empty">No posts yet. Check back Friday.</div>
            ) : (
              <PostList posts={posts} onSelect={setSelected} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Blog;
